import { Navigate, Route, Routes } from 'react-router-dom';
import { useAtomValue } from 'jotai';

import { ContentWrapper, Main, PageWrapper } from './index.styles';

import Footer from '../../footer';
import Header from '../../header';
import OnboardingDetails from './details';
import OnboardingPlan from './plan';

import { maybeCurrentBusinessState } from '../../../store';

export default function OnboardingPage() {
  const maybeCurrentBusiness = useAtomValue(maybeCurrentBusinessState);

  const hasPlan = !maybeCurrentBusiness || Boolean(maybeCurrentBusiness.plan_id);

  if (hasPlan) {
    return <Navigate to="/" />;
  }

  return (
    <PageWrapper>
      <Header />
      <Routes>
        <Route
          path="plan"
          element={
            <ContentWrapper wider>
              <Main>
                <OnboardingPlan />
              </Main>
            </ContentWrapper>
          }
        />
        <Route
          path="details"
          element={
            <ContentWrapper>
              <Main>
                <OnboardingDetails />
              </Main>
            </ContentWrapper>
          }
        />
        <Route path="*" element={<Navigate to="plan" />} />
      </Routes>
      <Footer />
    </PageWrapper>
  );
}
